import { AlertTriangle, ChevronDown, Calendar, ShieldCheck } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export const PatientBanner = ({ patient, patients, onSwitch }) => {
  return (
    <div className="rounded-2xl border border-slate-200/70 bg-white p-5 shadow-[0_2px_8px_rgba(0,0,0,0.04)] md:p-6">
      <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
        <div className="flex items-center gap-4">
          <img
            src={patient.avatar}
            alt={patient.name}
            className="h-14 w-14 rounded-2xl object-cover ring-1 ring-slate-200"
          />
          <div>
            <div className="flex flex-wrap items-center gap-2">
              <h1 className="font-heading text-xl font-bold tracking-tight text-slate-900 sm:text-2xl">
                {patient.name}
              </h1>
              {patient.alerts.map((a) => (
                <span
                  key={a}
                  data-testid="patient-alert"
                  className="inline-flex items-center gap-1.5 rounded-full border border-red-200/70 bg-red-50 px-2.5 py-1 text-xs font-semibold text-red-700"
                >
                  <AlertTriangle className="h-3.5 w-3.5" />
                  {a}
                </span>
              ))}
            </div>
            <div className="mt-1 flex flex-wrap items-center gap-x-4 gap-y-1 text-sm text-slate-500">
              <span>{patient.age} anos</span>
              <span className="flex items-center gap-1.5">
                <ShieldCheck className="h-3.5 w-3.5 text-blue-500" />
                {patient.plan}
              </span>
              <span className="flex items-center gap-1.5">
                <Calendar className="h-3.5 w-3.5 text-slate-400" />
                Última consulta: {patient.lastVisit}
              </span>
            </div>
          </div>
        </div>

        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <button
              data-testid="switch-patient-btn"
              className="flex items-center gap-2 self-start rounded-xl border border-slate-200 bg-white px-3.5 py-2 text-sm font-semibold text-slate-700 shadow-sm transition-colors duration-200 hover:bg-slate-50"
            >
              Trocar paciente
              <ChevronDown className="h-3.5 w-3.5 text-slate-400" />
            </button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="w-64">
            {patients.map((p) => (
              <DropdownMenuItem
                key={p.id}
                data-testid={`patient-option-${p.id}`}
                onClick={() => onSwitch(p.id)}
                className="cursor-pointer gap-3 py-2"
              >
                <img src={p.avatar} alt={p.name} className="h-8 w-8 rounded-lg object-cover" />
                <div className="flex flex-col">
                  <span className="text-sm font-semibold text-slate-800">{p.name}</span>
                  <span className="text-xs text-slate-400">
                    {p.age} anos · {p.plan}
                  </span>
                </div>
                {p.id === patient.id && (
                  <span className="ml-auto h-1.5 w-1.5 rounded-full bg-blue-600" />
                )}
              </DropdownMenuItem>
            ))}
          </DropdownMenuContent>
        </DropdownMenu>
      </div>

      <div className="mt-4 rounded-xl border border-slate-100 bg-slate-50/70 p-3.5">
        <p className="text-[11px] font-semibold uppercase tracking-wide text-slate-400">
          Queixa Principal
        </p>
        <p className="mt-1 text-sm text-slate-700">{patient.complaint}</p>
      </div>
    </div>
  );
};
